import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './DocumentDetail.css'

const DocumentDetails = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { document } = location.state || {};
  if (!document) {
    return (
      <div>
        <p>{t("DocumentsDetails.noDocumentDetails")}</p>
        <button onClick={() => navigate(-1)}>{t("DocumentsDetails.backToList")}</button>
      </div>
    );
  }

  return (
    <div className="document-detail-page">
      <h1>{t("DocumentsDetails.documents")}</h1>
      <div className="document-detail">
        <p>
          <strong>{t("DocumentsDetails.nameLabel")}</strong> {document.title}
        </p>
        <p>
          <strong>{t("DocumentsDetails.descriptionLabel")}</strong> {document.description}
        </p>
        <button onClick={() => navigate(-1)}>{t("DocumentsDetails.backToList")}</button>
      </div>
    </div>
  );
};

export default DocumentDetails;
